export enum CardStatus {
  Active = 0,
  Inactive = 1,
}
